import { capabilities } from '../../capabilities';
import { getPortalId } from '../../common/utils';
import { defineComponent } from '../../platform/models';
import { IN_APP_HELP_COMPONENT } from '../constants';
import { getFunctions, getInAppHelpQueryParams, getStyle } from './internal';
export const IN_APP_HELP_COMPONENT_ID = 'in-app-help-iframe';
export const inAppHelpNavComponentDef = defineComponent(IN_APP_HELP_COMPONENT, {
  name: IN_APP_HELP_COMPONENT,
  path: `/in-app-help/${getPortalId()}`,
  queryParams: getInAppHelpQueryParams(),
  capabilities: [capabilities.HIDE_COMPONENT_CAP.getName(), capabilities.RESTYLE_CAP.getName()],
  iframeProps: {
    id: IN_APP_HELP_COMPONENT_ID,
    ['data-test-id']: IN_APP_HELP_COMPONENT_ID,
    style: getStyle()
  },
  initiallyOpen: false,
  deferLoading: true,
  functions: getFunctions(),
  tags: []
});